<!-- components/CursuriInotOtopeni.vue -->
<template>
  <div class="cursuri-inot-layout bg-grey">
    <!-- SMART FIXED SIDEBAR – stops before page end -->
    <aside
      class="smart-sidebar black--text"
      :style="{ position: sidebarPosition }"
      ref="sidebar"
    >
      <v-list nav class="px-4">
        <div class="pa-6 mt-8 text-center">
          <h2 class="text-h5 primary--text font-weight-bold">AQUA SYA</h2>
          <p class="text-caption mt-2 opacity-8">Cursuri de natație</p>
        </div>
        <v-list-item
          v-for="item in sections"
          :key="item.id"
          @click="scrollTo(item.id)"
          class="nav-item black--text mb-2"
          link
        >
          <v-list-item-icon>
            <v-icon color="black">{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-title class="subtitle-1 pr-10">{{
            item.title
          }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </aside>

    <!-- SCROLLABLE RIGHT CONTENT -->
    <div class="scrollable-content">
      <v-container fluid>
        <v-row justify="center">
          <v-col cols="12">
            <!-- SECTION: Despre cursuri -->
            <section id="despre" class="section pb-16">
              <!-- Desktop & Tablet version (sm and up) - uses v-img with gradient -->
              <v-img
                height="660"
                src="https://lpin.ro/imagini/locatii/1/13.jpg"
                gradient="to bottom, rgba(0,0,0,0), rgba(0,0,0,0.2), rgba(0,0,0,0.7)"
                class="d-none d-sm-flex align-center justify-center"
              >
                <v-container
                  class="text-center mb-15"
                  style="max-width: 1200px"
                >
                  <h1
                    class="
                      display-3
                      font-weight-black
                      mb-6
                      text-shadow-lg
                      white--text
                    "
                  >
                    Cursuri de înot Otopeni
                  </h1>
                  <p
                    class="
                      display-1
                      font-weight-medium
                      mb-10
                      text-shadow-md
                      white--text
                    "
                  >
                    Lecții profesionale pentru copii în bazinul olimpic premium
                  </p>

                  <!-- <v-btn
                    x-large
                    depressed
                    class="
                      py-7
                      rounded-xl
                      green
                      darken-1
                      font-weight-bold
                      elevation-16
                    "
                    href="https://forms.gle/V7J5HC3kjHiNR9J49"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span class="mr-1">Completează</span> formularul de
                    înscriere
                    <v-icon right size="36">mdi-arrow-right</v-icon>
                  </v-btn> -->

                  <!-- <p
                    class="
                      text-h6
                      mt-6
                      font-weight-light
                      text-shadow-sm
                      white--text
                      opacity-90
                    "
                  >
                    Începe aventura în apă astăzi!
                  </p> -->
                </v-container>
              </v-img>
              <div class="hidden-sm-and-up">
 <v-img
  height="500"
  src="https://lpin.ro/imagini/locatii/1/13.jpg"
  gradient="to bottom, rgba(0,0,0,0), rgba(0,0,0,0.2), rgba(0,0,0,0.7)"
  class="d-flex align-center justify-center "
  style="position: relative;"
>
  <!-- Full-width container with built-in mobile padding, text perfectly centered -->
  <v-container
    fluid
    class="text-center pa-4 pa-sm-0 "
    style="position: absolute; top: 0; left: 0; right: 0; bottom: 0;"
  >
    <h1 class="display-3 font-weight-black my-6 text-shadow-lg white--text">
      Cursuri de înot Otopeni
    </h1>
    <p class="display-1 font-weight-medium mb-10 text-shadow-md white--text">
      Lecții profesionale pentru copii în bazinul olimpic premium
    </p>

    <!-- Responsive button size -->
    <!-- <v-btn
      :x-large="!$vuetify.breakpoint.xs"
      x-small
      depressed
      class="py-7 rounded-xl green darken-1 font-weight-bold elevation-16"
      href="https://forms.gle/V7J5HC3kjHiNR9J49"
      target="_blank"
      rel="noopener noreferrer"
    >
      <span class="mr-1" v-if="!$vuetify.breakpoint.xs">Completează</span> formularul de înscriere
      <v-icon right size="36">mdi-arrow-right</v-icon>
    </v-btn> -->

    <!-- <p class="text-h6 mt-6 font-weight-light text-shadow-sm white--text opacity-90">
      Începe aventura în apă astăzi!
    </p> -->
  </v-container>
</v-img>
              </div>





              <!-- Text below the hero image -->
              <v-container class="mt-12">
                <v-row justify="center">
                  <v-col cols="12" md="10">
                    <div class="text-center mb-16">
                      <p
                        class="
                          text-h5
                          font-weight-medium
                          grey--text
                          text--darken-4
                          leading-8
                          mx-auto
                        "
                        style="max-width: 1000px"
                      >
                        <span class="primary--text font-weight-black"
                          >Aqua SYA</span
                        >
                        îți oferă lecții de înot de cea mai înaltă calitate în
                        incinta
                        <span class="primary--text font-weight-bold"
                          >Complexului de Natație Otopeni</span
                        >
                        (Strada Drumul Gării Otopeni 5-11) – un bazin olimpic
                        modern cu condiții excepționale pentru toate vârstele.
                      </p>

                      <p
                        class="
                          text-h5
                          font-weight-medium
                          grey--text
                          text--darken-4
                          leading-8
                          mt-10
                          mx-auto
                        "
                        style="max-width: 1000px"
                      >
                        La
                        <span class="primary--text font-weight-black"
                          >Aqua SYA</span
                        >
                        credem că înotul nu este doar o

                        <span class="primary--text font-weight-bold"
                          >abilitate esențială</span
                        >
                         ci și o sursă autentică de bucurie.
                        
                       Indiferent dacă doresti inscrierea la cursuri de performanță sau de initiere, beneficiezi de
                        <span class="primary--text font-weight-bold"
                          >antrenori calificați</span
                        > si de programe personalizate.
                      </p>
                    

                      <p class="text-h6 font-weight-bold primary--text mt-12">
                        Mai jos găsești lista actualizată cu prețurile pentru
                        lecțiile de înot la Otopeni.
                      </p>
                    </div>
                  </v-col>
                </v-row>
              </v-container>
            </section>

            <!-- SECTION: Instructor -->
            <section id="instructori" class="section py-16 primary">
              <v-container>
                <v-row align="start" justify="center">
                  <v-col cols="12" md="5" lg="4" class="text-center">
                    <v-avatar size="320" rounded="xl" class="elevation-12">
                      <v-img
                        :src="require('@/assets/swimming/swimmingCoach.jpg')"
                        cover
                        class="rounded-xl"
                      ></v-img>
                    </v-avatar>
                    <p
                      class="
                        text-h6
                        white--text
                        mt-6
                        opacity-9
                        font-weight-medium
                      "
                    >
                      Comboeanu Cristian
                    </p>
                  </v-col>

                  <v-col cols="12" md="7" lg="8">
                    <p class="text-overline white--text opacity-8">
                      Instructor principal
                    </p>
                    <h2 class="display-2 font-weight-black white--text mb-8">
                      Comboeanu Cristian
                    </h2>

                    <p class="text-h6 white--text font-weight-bold mb-8">
                      Cu peste
                      <span class="black--text font-weight-bold"
                        >15 ani de experiență</span
                      >
                      în natație de performanță și predare, Cristian este
                      antrenorul principal al programelor Aqua SYA.
                    </p>

                    <p class="text-h6 white--text opacity-9 leading-8 mb-12">
                      Abordarea sa este una
                      <span class="black--text font-weight-bold"
                        >personalizată</span
                      >: pune accent pe
                      <span class="black--text font-weight-bold">siguranță</span
                      >, progres constant și plăcerea de a înota. Fiecare lecție
                      este structurată pentru a oferi
                      <span class="black--text font-weight-bold"
                        >rezultate vizibile</span
                      >
                      într-un mediu prietenos și profesionist.
                    </p>

                    <v-row justify="center">
                      <v-col cols="12" sm="6" md="4">
                        <v-card
                          class="
                            px-6
                            pb-6
                            text-center
                            rounded-xl
                            d-flex
                            flex-column
                            justify-center
                          "
                          :class="$vuetify.breakpoint.xs ? 'pt-6' : 'pt-0'"
                          color="white"
                          elevation="12"
                          height="100%"
                        >
                          <v-icon size="48" color="primary" class="mb-4"
                            >mdi-trophy</v-icon
                          >
                          <p
                            class="text-h5 font-weight-black primary--text mb-2"
                          >
                            15 ani de experiență
                          </p>
                          <p class="text-subtitle-1 grey--text text--darken-4">
                            performanță, predare dedicată și pasiune
                          </p>
                        </v-card>
                      </v-col>

                      <v-col cols="12" sm="6" md="4">
                        <v-card
                          class="
                            pa-6
                            text-center
                            rounded-xl
                            d-flex
                            flex-column
                            justify-center
                          "
                          color="white"
                          elevation="12"
                          height="100%"
                        >
                          <v-icon size="48" color="primary" class="mb-4"
                            >mdi-medal</v-icon
                          >
                          <p
                            class="text-h5 font-weight-black primary--text mb-2"
                          >
                            Campion național
                          </p>
                          <p class="text-subtitle-1 grey--text text--darken-4">
                            Titluri și medalii obținute la competiții de top
                          </p>
                        </v-card>
                      </v-col>

                      <v-col cols="12" sm="6" md="4">
                        <v-card
                          class="
                            pa-6
                            text-center
                            rounded-xl
                            d-flex
                            flex-column
                            justify-center
                          "
                          color="white"
                          elevation="12"
                          height="100%"
                        >
                          <v-icon size="48" color="primary" class="mb-4"
                            >mdi-account-heart</v-icon
                          >
                          <p
                            class="text-h5 font-weight-black primary--text mb-2"
                          >
                            Abordare personalizată
                          </p>
                          <p class="text-subtitle-1 grey--text text--darken-4">
                            Lecții adaptate fiecărui nivel și obiectiv
                            individual
                          </p>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-container>
            </section>

            <!-- SECTION: Program -->
            <section id="program" class="section py-16">
              <v-container>
                <div class="text-center mb-12">
                  <h2 class="display-2 font-weight-black primary--text mb-4">
                    Program disponibil
                  </h2>
                  <p
                    class="text-h5 grey--text text--darken-3 font-weight-medium"
                  >
                    Sesiunea durează 50 de minute
                  </p>
                </div>

                <!-- Desktop/Tablet Table -->
              <div class="d-none d-md-block">
  <v-card elevation="8" class="rounded-xl overflow-hidden">
    <v-card-title class="primary white--text py-5">
      <v-icon left size="28">mdi-clock-outline</v-icon>
      <span class="text-h5 font-weight-bold">Program săptămânal</span>
    </v-card-title>

    <table class="custom-table">
      <thead>
        <tr class="bg-primary black--text">
          <th class="text-left py-6 pl-8 font-weight-bold">Ora</th>
          <th class="text-center py-6 font-weight-bold">Luni</th>
          <th class="text-center py-6 font-weight-bold">Marți</th>
          <th class="text-center py-6 font-weight-bold">Miercuri</th>
          <th class="text-center py-6 font-weight-bold">Joi</th>
          <th class="text-center py-6 font-weight-bold">Vineri</th>
          <th class="text-center py-6 font-weight-bold">Sâmbătă</th>
          <th class="text-center py-6 font-weight-bold">Duminică</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="slot in timeSlots"
          :key="slot.time"
          class="hover-row"
        >
          <td
            class="py-8 pl-8 font-weight-bold primary--text text-h6"
          >
            {{ slot.time }}
          </td>
          <td
            v-for="day in ['Luni', 'Marți', 'Miercuri', 'Joi', 'Vineri', 'Sâmbătă', 'Duminică']"
            :key="day"
            class="text-center py-8"
            :class="{ 'available-slot': slot[day] }"
          >
            <v-icon
              v-if="slot[day]"
              size="40"
              color="green darken-2"
            >
              mdi-check-circle
            </v-icon>
            <v-icon
              v-else
              size="40"
              color="black lighten-1"
              class="opacity-30"
            >
              mdi-close-circle
            </v-icon>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- Weekend notice section -->
    <div class="pa-6 text-center primary ">
      <h3 class="text-h6 font-weight-bold mb-3 white--text">
        Sâmbătă și Duminică – program special
      </h3>
      <p class="body-1 mb-4">
        În weekend programul nu este fix. Pentru a face o programare te rugăm să ne contactezi direct.
      </p>
      
      <div class="d-flex flex-column flex-sm-row align-center justify-center gap-4">
     

        <!-- Phone number (click-to-call on mobile) -->
        <v-chip
          outlined
          large
          color="white"
          class="font-weight-medium px-6 py-5"
        >
          <a href="tel:+40773733262" class="white--text text-decoration-none d-flex align-center gap-2">
  <v-icon color="white">mdi-phone</v-icon>
  <span class="text-body-1 font-weight-medium">+40 773 733 262</span>
</a>
        </v-chip>
      </div>
    </div>
  </v-card>
</div>

                <!-- Mobile List -->
             <!-- Mobile List -->
<div class="d-md-none">
  <v-card
    v-for="slot in timeSlots"
    :key="slot.time"
    class="mb-6 rounded-xl overflow-hidden"
    elevation="8"
  >
    <v-card-title class="primary white--text py-4">
      <v-icon left size="28">mdi-clock</v-icon>
      <span class="text-h6 font-weight-bold">{{ slot.time }}</span>
    </v-card-title>
    <v-card-text class="pt-6 pb-4">
      <v-row dense align="center">
        <v-col
          v-for="day in ['Luni', 'Marți', 'Miercuri', 'Joi', 'Vineri', 'Sâmbătă', 'Duminică']"
          :key="day"
          cols="6"
          class="text-center py-4"
        >
          <div
            class="text-overline grey--text text--darken-3 mb-3 font-weight-medium"
          >
            {{ day }}
          </div>
          <v-icon
            v-if="slot[day]"
            size="48"
            color="green darken-2"
          >
            mdi-check-circle
          </v-icon>
          <v-icon v-else size="48" color="black lighten-1">
            mdi-close-circle
          </v-icon>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>

  <!-- Weekend notice section – shown once at the bottom on mobile -->
  <v-card
    class="mt-8 rounded-xl overflow-hidden"
    elevation="8"
  >
    <v-card-text class="pa-6 text-center primary ">
      <h3 class="text-h6 font-weight-bold mb-4 white--text">
        Sâmbătă și Duminică – program special
      </h3>
      
      <p class="body-1 mb-5">
        În weekend programul nu este fix. Pentru a face o programare te rugăm să ne contactezi direct.
      </p>

      <div class="d-flex flex-column align-center gap-4">
    

        <!-- Phone number (click-to-call) -->
        <v-chip
          outlined
          large
          color="white"
          class="px-6 py-5 font-weight-medium"
        >
          <v-icon left color="white">mdi-phone</v-icon>
          <a 
            href="tel:+40773733262" 
            class="white--text text-decoration-none"
          >
            +40 773 733 262
          </a>
        </v-chip>
      </div>
    </v-card-text>
  </v-card>
</div>
              </v-container>
            </section>

            <!-- SECTION: CONTACT -->
            <section id="contact" class="section py-16">
              <v-img
                height="400"
                src="https://www.shutterstock.com/image-photo/blur-background-tranquil-indoor-swimming-260nw-2580064141.jpg"
                gradient="to bottom, rgba(0,0,0,0.4), rgba(0,0,0,0.6)"
                class="white--text"
              >
                <v-container
                  class="
                    fill-height
                    d-flex
                    align-center
                    justify-center
                    ma-0
                    pa-0
                  "
                  fluid
                >
                  <div class="text-center">
                    <h2 class="display-3 font-weight-black mb-6">
                      Contactează-ne
                    </h2>
                    <p class="display-1 font-weight-medium">
                      Suntem aici să răspundem la toate întrebările tale despre
                      cursurile de înot!
                    </p>
                  </div>
                </v-container>
              </v-img>

              <v-container class="mt-n10">
                <v-row justify="center">
                  <v-col cols="12" md="10">
                    <v-row>
                      <v-col cols="12" md="4">
                        <v-card
                          class="pa-8 text-center rounded-xl"
                          elevation="8"
                          height="100%"
                        >
                          <v-icon size="64" color="primary" class="mb-4"
                            >mdi-phone</v-icon
                          >
                          <h3 class="text-h5 font-weight-bold mb-3">Telefon</h3>
                          <p class="text-h6 black--text">+40 0773 733 262</p>
                          <p class="text-subtitle-2 grey--text text--darken-4">
                            Sună-ne pentru programări rapide
                          </p>
                          <v-btn
                            href="https://wa.me/40773733262"
                            target="_blank"
                            color="green darken-1"
                            dark
                            large
                            class="mt-6 rounded-lg"
                            outlined
                          >
                            <v-icon left>mdi-whatsapp</v-icon>
                            Mesaj pe WhatsApp
                          </v-btn>
                        </v-card>
                      </v-col>

                      <v-col cols="12" md="4">
                        <v-card
                          class="py-8 px-6 text-center rounded-xl"
                          elevation="8"
                          height="100%"
                        >
                          <v-icon size="64" color="primary" class="mb-4"
                            >mdi-email</v-icon
                          >
                          <h3 class="text-h5 font-weight-bold mb-3">Email</h3>
                          <p class="text-h6 black--text">
                            aquasyaswim@gmail.com
                          </p>
                          <p class="text-subtitle-2 grey--text text--darken-4">
                            Răspundem în maxim 24 de ore
                          </p>
                          <v-btn
                            :href="'mailto:aquasyaswim@gmail.com'"
                            color="primary"
                            large
                            class="mt-6 rounded-lg"
                            outlined
                          >
                            <v-icon left>mdi-email</v-icon>
                            Trimite Email
                          </v-btn>
                        </v-card>
                      </v-col>

                      <v-col cols="12" md="4">
                        <v-card
                          class="pa-8 text-center rounded-xl"
                          elevation="8"
                          height="100%"
                        >
                          <v-icon size="64" color="primary" class="mb-4"
                            >mdi-clock-outline</v-icon
                          >
                          <h3 class="text-h5 font-weight-bold mb-3">
                            Program Contact
                          </h3>
                          <p class="text-h6 black--text">
                            Luni - Vineri: 9:00 - 20:00
                          </p>
                          <p class="text-h6 black--text">
                            Sâmbătă - Duminică: 9:00 - 14:00
                          </p>
                          <p
                            class="
                              text-subtitle-2
                              grey--text
                              text--darken-4
                              mt-4
                            "
                          >
                            Cel mai rapid răspuns pe WhatsApp!
                          </p>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-container>
            </section>

            <!-- SECTION: Poza bazin -->
            <section id="bazin" class="section pa-0">
              <v-img
                height="600"
                :src="require('@/assets/swimming/swimming.jpg')"
                class="w-100"
              >
                <div class="d-flex align-center justify-center fill-height">
                  <div class="text-center">
                    <h2
                      class="display-3 font-weight-black white--text"
                      style="
                        text-shadow: 4px 4px 10px #000;
                        letter-spacing: 2px;
                        margin-bottom: 230px;
                      "
                    >
                      Bazin Olimpic Otopeni
                    </h2>
                  </div>
                </div>
              </v-img>
            </section>

            <!-- SECTION: PRETURI INDIVIDUALE -->
            <section id="preturi-individuale" class="section py-16">
              <v-container fluid class="pa-0">
                <v-row justify="center">
                  <v-col cols="11">
                    <div class="text-center mb-12 px-4">
                      <h2
                        class="display-2 font-weight-black primary--text mb-4"
                      >
                        Abonamente Individuale
                      </h2>
                      <p class="text-h6 grey--text text--darken-4">
                        Prețul este pentru o persoană • Lecții 1 la 1 cu
                        antrenorul
                      </p>
                    </div>

                    <v-card
                      elevation="8"
                      class="rounded-xl overflow-hidden mx-auto"
                      max-width="100%"
                    >
                      <div class="pa-8 text-center primary white--text">
                        <div class="d-flex align-center justify-center">
                          <v-icon
                            size="56"
                            :class="$vuetify.breakpoint.xs ? 'mr-1' : 'mr-6'"
                            >mdi-account-tie</v-icon
                          >
                          <div>
                            <h3 class="display-1 font-weight-black mb-1">
                              Individual
                            </h3>
                            <p class="text-h6 opacity-90 ma-0">
                              Atenție maximă • Progres rapid
                            </p>
                          </div>
                        </div>
                      </div>

                      <div
                        v-for="(item, index) in individualPrices"
                        :key="index"
                        class="price-row"
                        :class="{ 'recommended-row': item.recommended }"
                      >
                        <div
                          class="d-flex align-center justify-space-between pa-8"
                        >
                          <div class="d-flex align-center">
                            <v-icon size="36" color="primary" class="mr-6"
                              >mdi-calendar-clock</v-icon
                            >
                            <div>
                              <div class="text-h5 font-weight-bold black--text">
                                {{ item.sedinta }}
                              </div>
                              <div
                                class="
                                  text-body-1
                                  grey--text
                                  text--darken-2
                                  mt-1
                                "
                              >
                                {{ item.benefit || "" }}
                              </div>
                            </div>
                          </div>
                          <div class="text-right">
                            <div
                              class="text-h4 font-weight-black primary--text"
                            >
                              {{ item.pret }}
                            </div>
                            <v-chip
                              v-if="item.recommended"
                              small
                              color="primary"
                              dark
                              class="mt-3"
                            >
                              <v-icon small left>mdi-star</v-icon> Cel mai
                              popular
                            </v-chip>
                          </div>
                        </div>
                      </div>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>
            </section>

            <!-- SECTION: PRETURI GRUP -->
            <section id="preturi-grup" class="section py-16">
              <v-container fluid class="pa-0">
                <v-row justify="center">
                  <v-col cols="11">
                    <div class="text-center mb-12 px-4">
                      <h2
                        class="display-2 font-weight-black primary--text mb-4"
                      >
                        Abonamente de Grup
                      </h2>
                      <p class="text-h6 grey--text text--darken-4">
                        Prețul este pentru o persoană • Grup mic (max 4 - 6
                        persoane)
                      </p>
                    </div>

                    <v-card
                      elevation="8"
                      class="rounded-xl overflow-hidden mx-auto"
                      max-width="100%"
                    >
                      <div class="pa-8 text-center green darken-1 white--text">
                        <div class="d-flex align-center justify-center">
                          <v-icon
                            size="56"
                            :class="$vuetify.breakpoint.xs ? 'mr-1' : 'mr-6'"
                            >mdi-account-group</v-icon
                          >
                          <div>
                            <h3 class="display-1 font-weight-black mb-1">
                              Grup
                            </h3>
                            <p class="text-h6 opacity-90 ma-0">
                              Distracție • Motivație colectivă • Preț avantajos
                            </p>
                          </div>
                        </div>
                      </div>

                      <div
                        v-for="(item, index) in groupPrices"
                        :key="index"
                        class="price-row"
                        :class="{ 'recommended-row': item.recommended }"
                      >
                        <div
                          class="d-flex align-center justify-space-between pa-8"
                        >
                          <div class="d-flex align-center">
                            <v-icon
                              size="36"
                              color="green darken-1"
                              class="mr-6"
                              >mdi-calendar-clock</v-icon
                            >
                            <div>
                              <div class="text-h5 font-weight-bold black--text">
                                {{ item.sedinta }}
                              </div>
                              <div
                                class="
                                  text-body-1
                                  grey--text
                                  text--darken-2
                                  mt-1
                                "
                              >
                                {{ item.benefit || "" }}
                              </div>
                            </div>
                          </div>
                          <div class="text-right">
                            <div
                              class="
                                text-h4
                                font-weight-black
                                green--text
                                text--darken-3
                              "
                            >
                              {{ item.pret }}
                            </div>
                            <v-chip
                              v-if="item.recommended"
                              small
                              color="green darken-1"
                              dark
                              class="mt-3"
                            >
                              <v-icon small left>mdi-star</v-icon> Cel mai
                              popular
                            </v-chip>
                          </div>
                        </div>
                      </div>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>
            </section>

            <!-- SECTION: Harta -->
            <section id="locatie" class="section pa-10 mb-16">
              <v-container>
                <p class="text-center text-h6 mt-6 black--text">
                  Strada Drumul Gării Otopeni 5-11, Complexul de Natație Otopeni
                </p>

                <div class="map-responsive">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d2843.6600376526667!2d26.081720999999995!3d44.542593!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zNDTCsDMyJzMzLjMiTiAyNsKwMDQnNTQuMiJF!5e0!3m2!1sen!2sro!4v1766498365173!5m2!1sen!2sro"
                    width="100%"
                    height="450"
                    style="border: 0"
                    allowfullscreen=""
                    loading="lazy"
                    referrerpolicy="no-referrer-when-downgrade"
                  ></iframe>
                </div>
              </v-container>
            </section>
          </v-col>
        </v-row>
      </v-container>

      <!-- Invisible anchor for sidebar -->
      <div ref="endTrigger" style="height: 1px"></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      valid: false,
      sidebarPosition: "fixed",
      timeSlots: [
        {
          time: "16:00 - 17:00",
          Luni: true,
          Marți: true,
          Miercuri: true,
          Joi: true,
          Vineri: true,
          Sâmbătă: true,
          Duminică: true,
        },
      ],
      individualHeaders: [
        {
          text: "Tip abonament",
          value: "sedinta",
          align: "start",
          sortable: false,
        },
        { text: "Preț", value: "pret", align: "end", sortable: false },
      ],
      individualPrices: [
        { sedinta: "1 ședință individuală", pret: "250 Lei" },
        { sedinta: "4 ședințe individuale", pret: "850 Lei" },
      ],
      sections: [
        { id: "despre", title: "Despre cursuri", icon: "mdi-information" },
        { id: "instructori", title: "Instructori", icon: "mdi-account-tie" },
        { id: "program", title: "Program", icon: "mdi-calendar-month" },
        { id: "contact", title: "Contact", icon: "mdi-phone" },
        // { id: "bazin", title: "Bazin", icon: "mdi-pool" },
        {
          id: "preturi-individuale",
          title: "Prețuri individuale",
          icon: "mdi-currency-usd",
        },
        {
          id: "preturi-grup",
          title: "Prețuri grup",
          icon: "mdi-account-group",
        },
        { id: "locatie", title: "Locație & Hartă", icon: "mdi-map-marker" },
      ],
      groupHeaders: [
        { text: "Număr ședințe", value: "sedinta", sortable: false },
        { text: "Preț", value: "pret", align: "end", sortable: false },
      ],
      groupPrices: [
        { sedinta: "1 ședință în grup", pret: "200 Lei" },
        { sedinta: "4 ședințe în grup", pret: "600 Lei" },
        { sedinta: "8 ședințe în grup", pret: "1.000 Lei" },
      ],
    };
  },

  methods: {
    scrollTo(id) {
      const el = document.getElementById(id);
      if (el) {
        const offset = 100;
        const y = el.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top: y, behavior: "smooth" });
      }
    },
  },
};
</script>

<style scoped>
.text-shadow-sm {
  text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.8);
}

.text-shadow-md {
  text-shadow: 2px 2px 6px rgba(0, 0, 0, 0.9);
}

.text-shadow-lg {
  text-shadow: 3px 3px 8px rgba(0, 0, 0, 0.9);
}

/* Optional: stronger button shadow for depth */
.elevation-20 {
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.4),
    0 10px 10px -5px rgba(0, 0, 0, 0.3) !important;
}
.price-row {
  border-top: 1px solid rgba(0, 0, 0, 0.08);
}

.price-row:nth-child(even) {
  background-color: rgba(0, 0, 0, 0.02);
}

.price-row:hover {
  background-color: rgba(0, 0, 0, 0.05) !important;
  transition: background-color 0.3s ease;
}

/* Ensure last row has bottom border for visual closure */
.price-row:last-child {
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}

/* Mobile adjustments */
@media (max-width: 600px) {
  .d-flex {
    flex-direction: column;
    text-align: center;
    gap: 8px;
  }

  .text-h4 {
    font-size: 2rem !important;
  }
}
.custom-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}

.custom-table th {
  position: sticky;
  top: 0;
  z-index: 2;
}

.hover-row:hover {
  background-color: rgba(0, 0, 0, 0.05) !important;
  transition: background-color 0.3s ease;
}

.available-slot {
  background-color: rgba(
    76,
    175,
    80,
    0.08
  ); /* subtle green tint for available */
}
.highlight-bold {
  @apply black--text font-weight-bold; /* If using Tailwind-like utilities */
  /* Or plain Vuetify classes */
}
.price-table th {
  font-size: 1.1rem !important;
  font-weight: 700 !important;
  color: #000 !important;
  background-color: #f5f5f5 !important;
}

.price-table tr:hover {
  background-color: #e3f2fd !important;
}

.cursuri-inot-layout {
  position: relative;
  min-height: 100vh;
}

.scrollable-content {
  margin-left: 310px;
  padding-top: 64px;
  min-height: calc(100vh - 64px);
  background: #f8f9fa;
}

.section:first-child {
  padding-top: 0px !important;
}

.section {
  min-height: 80vh;
  scroll-margin-top: 120px;
}

.nav-item {
  border-left: 4px solid transparent;
  transition: all 0.3s ease;
  margin: 0 8px;
}

.nav-item:hover,
.nav-item.v-list-item--active {
  background: rgba(255, 255, 255, 0.2) !important;
  border-left-color: black !important;
}

/* Mobile improvements */
@media (max-width: 960px) {
  .scrollable-content {
    margin-left: 0 !important;
    padding-top: 56px;
  }

  .smart-sidebar {
    display: none;
  }

  .section {
    min-height: auto;
    padding: 40px 16px !important;
  }

  #despre .v-img {
    height: 400px !important;
  }
}

@media (max-width: 600px) {
  #despre .v-img {
    height: 350px !important;
  }

  .display-3 {
    font-size: 2.5rem !important;
  }

  .display-1 {
    font-size: 1.8rem !important;
  }
}
</style>
